<template></template>

<script>
import { setAccessToken, getAccessToken } from '@/auth/auth';

export default {
  name: '',
  mounted() {

      this.$nextTick(() => {
          var code = this.$route.query.code;

          setAccessToken(code);

         if(typeof getAccessToken() != 'undefined')
              this.$router.push('/')
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Callback.vue?7cd0fc94